// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HuddleTasksSection-module__headerRow___USY5M {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 16px 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.HuddleTasksSection-module__headerRow___USY5M:hover {
  background: #fafafa;
}

.HuddleTasksSection-module__headerTitle___g48_R {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 17px;
  font-weight: 600;
  color: #18181b;
}

.HuddleTasksSection-module__chevron___e0kzl {
  color: #a1a1aa;
  transition: transform 0.15s ease;
}

.HuddleTasksSection-module__chevronOpen___huKGB {
  transform: rotate(90deg);
}

.HuddleTasksSection-module__headerMeta___Z1BJl {
  font-size: 14px;
  color: #71717a;
}

.HuddleTasksSection-module__emptyRow___j21xK {
  padding: 16px 20px;
  font-size: 14px;
  color: #71717a;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/HuddleTasksSection/HuddleTasksSection.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,gCAAA;AAAF;;AAGA;EACE,wBAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AAAF","sourcesContent":[".headerRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  padding: 16px 20px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n}\n\n.headerRow:hover {\n  background: #fafafa;\n}\n\n\n.headerTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 17px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.chevron {\n  color: #a1a1aa;\n  transition: transform 0.15s ease;\n}\n\n.chevronOpen {\n  transform: rotate(90deg);\n}\n\n.headerMeta {\n  font-size: 14px;\n  color: #71717a;\n}\n\n.emptyRow {\n  padding: 16px 20px;\n  font-size: 14px;\n  color: #71717a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerRow": `HuddleTasksSection-module__headerRow___USY5M`,
	"headerTitle": `HuddleTasksSection-module__headerTitle___g48_R`,
	"chevron": `HuddleTasksSection-module__chevron___e0kzl`,
	"chevronOpen": `HuddleTasksSection-module__chevronOpen___huKGB`,
	"headerMeta": `HuddleTasksSection-module__headerMeta___Z1BJl`,
	"emptyRow": `HuddleTasksSection-module__emptyRow___j21xK`
};
module.exports = ___CSS_LOADER_EXPORT___;
